import { fromJS } from 'immutable';
import * as types from '../constants';
//import worldCupData from './WorldCupDemo1.json';

const initialState = fromJS({
  worldCup: [],
  worldCupCalendars: {},
});

export default function worldCupReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_WORLD_CUP_SUCCESS:
      return state.set('worldCup', (fromJS(action.data)));
      //return state.set('worldCup', fromJS(worldCupData.data));
    case types.GET_WORLD_CUP_DAY_CALENDAR_SUCCESS:
      return state.mergeIn(['worldCupCalendars'], { [action.widgetId]: fromJS(action.data) });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/worldCup.js